// Materialize menu content before the existing interaction handlers see the event.
(() => {
  "use strict";

  const ready = new WeakSet();
  const hydrate = root => {
    if (!root || ready.has(root)) return;
    const templates = root.matches?.("template[data-jl-lazy]")
      ? [root] : Array.from(root.querySelectorAll("template[data-jl-lazy]"));
    ready.add(root);
    if (!templates.length) return;
    templates.forEach(template => template.replaceWith(template.content));
    root.dispatchEvent(new CustomEvent("jl:hydrated", { bubbles: true }));
  };
  const desktop = event => {
    const item = event.target.closest(".jl-mm__item");
    if (item) hydrate(item.querySelector("[data-jl-panel]"));
  };
  ["pointerover", "focusin", "click"].forEach(type => {
    document.addEventListener(type, desktop, true);
  });
  document.addEventListener("touchstart", desktop, { capture: true, passive: true });
  document.addEventListener("click", event => {
    const button = event.target.closest("button[data-jl-mobile]");
    if (!button) return;
    const menu = button.closest(".jl-mm-mobile");
    const pane = document.getElementById(button.dataset.jlMobile);
    if (menu && pane && menu.contains(pane)) hydrate(pane);
  }, true);

  window.JLMenu = { hydrate };
})();

(()=>{"use strict";const c=(a,d=document)=>[...d.querySelectorAll(a)];const g=a=>c("img[data-src]",a).forEach(d=>{d.src=d.dataset.src;d.removeAttribute("data-src")});document.documentElement.classList.add("jl-mm-js");c(".jl-mm").forEach(a=>{const d=c(".jl-mm__tab",a),warm=a.classList.contains("jl-mm--jainsons"),closing=new Map;let r,v,y,p,u=false;const E=()=>{clearTimeout(v);clearTimeout(y)};const j=e=>c(".jl-mm__flyout li",e).forEach(s=>{s.classList.remove("is-active","is-flip");s.firstElementChild?.hasAttribute("aria-expanded")&&s.firstElementChild.setAttribute("aria-expanded","false")});const m=(animate=false)=>{E();clearTimeout(p);if(warm){closing.forEach((timer,item)=>{clearTimeout(timer);item.classList.remove("is-closing")});closing.clear()}if(!r)return;j(r);if(warm&&animate&&!matchMedia("(prefers-reduced-motion: reduce)").matches){const old=r;old.querySelector("[data-jl-panel]").inert=true;old.classList.add("is-closing");closing.set(old,setTimeout(()=>{old.classList.remove("is-closing");closing.delete(old)},120))}r.classList.remove("is-open");r.querySelector("[data-jl-open]").setAttribute("aria-expanded","false");r=null};const L=e=>{const s=e.querySelector("[data-jl-panel]"),i=e.querySelector("[data-jl-open]");if(s.classList.contains("jl-mm__panel--flyout")){const t=a.getBoundingClientRect(),f=i.getBoundingClientRect();const _=Math.max(0,Math.min(f.left,innerWidth-s.offsetWidth-8)-t.left);s.style.setProperty("--jl-tab-left",_+"px")}};const h=e=>{const s=e.closest("[data-jl-panel]");c("[data-jl-rail]",s).forEach(t=>{t.classList.toggle("is-active",t===e);t.setAttribute("aria-expanded",String(t===e))});c("[data-jl-tiles]",s).forEach(t=>{const f=t.dataset.jlTiles===e.dataset.jlRail;t.classList.toggle("is-active",f);if(f)g(t)});const i=s.querySelector(".jl-mm__marker");i.style.top=e.offsetTop+"px";i.style.height=e.offsetHeight+"px"};const l=e=>{E();const s=e.closest(".jl-mm__item"),switching=!!r&&r!==s||closing.size>0,newOpen=r!==s;if(closing.has(s)){clearTimeout(closing.get(s));closing.delete(s);s.classList.remove("is-closing")}if(warm)s.querySelector("[data-jl-panel]").inert=false;if(r!==s){m();r=s}s.classList.add("is-open");e.setAttribute("aria-expanded","true");L(s);const i=s.querySelector("[data-jl-panel]");if(warm&&newOpen){i.classList.toggle("is-switching",switching);a.style.setProperty("--jl-panel-top",a.querySelector(".jl-mm__tabs").getBoundingClientRect().bottom+"px")}const t=i.querySelector("[data-jl-rail]");if(t)h(t);else g(i)};const n=e=>{clearTimeout(p);[...e.parentElement.children].forEach(i=>{i.classList.toggle("is-active",i===e);const t=i.firstElementChild;if(t.hasAttribute("aria-expanded"))t.setAttribute("aria-expanded",String(i===e));if(i!==e)j(i)});const s=e.querySelector(":scope > ul");if(s){e.classList.remove("is-flip");if(s.getBoundingClientRect().right>innerWidth-8)e.classList.add("is-flip")}};const o=e=>c('a[role="menuitem"]',e).filter(s=>s.getClientRects().length);d.forEach((e,s)=>{const i=e.closest(".jl-mm__item");e.addEventListener("keydown",t=>{if(t.key==="ArrowRight"||t.key==="ArrowLeft"){t.preventDefault();m();d[(s+(t.key==="ArrowRight"?1:-1)+d.length)%d.length].focus()}});if(!e.hasAttribute("data-jl-open")){i.addEventListener("pointerenter",t=>{if(t.pointerType!=="touch")m()});return}i.addEventListener("pointerenter",t=>{if(t.pointerType==="touch")return;E();v=setTimeout(()=>l(e),warm?80:120)});i.addEventListener("pointerleave",t=>{if(t.pointerType==="touch")return;E();y=setTimeout(()=>{if(!a.querySelector(".jl-mm__search-input:focus"))m(warm)},warm?200:300)});e.addEventListener("pointerdown",t=>{u=t.pointerType==="touch"||t.pointerType==="pen"});e.addEventListener("click",t=>{if(u&&r!==i||e.getAttribute("href")==="#"){t.preventDefault();l(e)}u=false});e.addEventListener("keydown",t=>{if(t.key==="ArrowDown"||t.key==="ArrowUp"){t.preventDefault();l(e);const f=o(i.querySelector("[data-jl-panel]"));(t.key==="ArrowDown"?f[0]:f.at(-1))?.focus()}})});c("[data-jl-rail]",a).forEach(e=>{let s;e.addEventListener("pointerenter",i=>{if(i.pointerType!=="touch")h(e)});e.addEventListener("focus",()=>h(e));e.addEventListener("pointerdown",i=>{u=i.pointerType==="touch"||i.pointerType==="pen";s=e.classList.contains("is-active")});e.addEventListener("click",i=>{if(u&&!s){i.preventDefault();h(e)}u=false})});c(".jl-mm__flyout li",a).forEach(e=>{let s;e.firstElementChild.addEventListener("pointerenter",i=>{if(i.pointerType==="touch")return;clearTimeout(p);const t=[...e.parentElement.children].find(f=>f!==e&&f.classList.contains("is-active")&&f.querySelector(":scope > ul"));if(t&&t.contains(i.relatedTarget))p=setTimeout(()=>n(e),200);else n(e)});e.firstElementChild.addEventListener("focus",()=>n(e));e.firstElementChild.addEventListener("pointerdown",i=>{u=i.pointerType==="touch"||i.pointerType==="pen";s=e.classList.contains("is-active")});e.firstElementChild.addEventListener("click",i=>{if(u&&e.querySelector(":scope > ul")&&!s){i.preventDefault();n(e)}u=false})});c(".jl-mm__flyout ul",a).forEach(e=>e.addEventListener("pointerenter",()=>clearTimeout(p)));a.addEventListener("keydown",e=>{if(!r||!e.target.closest("[data-jl-panel]"))return;const s=e.target.closest("a"),i=s?.closest(".jl-mm__flyout li");if(e.key==="ArrowDown"||e.key==="ArrowUp"){e.preventDefault();let t;if(i)t=[...i.parentElement.children].map(f=>f.firstElementChild);else t=c("[data-jl-rail]",r).includes(s)?c("[data-jl-rail]",r):o(s.closest("[data-jl-tiles],.jl-mm__grid")||r.querySelector("[data-jl-panel]"));t[(t.indexOf(s)+(e.key==="ArrowDown"?1:-1)+t.length)%t.length]?.focus()}if(e.key==="ArrowRight"){const t=i?.querySelector(":scope > ul");if(t){e.preventDefault();n(i);t.querySelector("a")?.focus()}else if(s?.hasAttribute("data-jl-rail")){e.preventDefault();o(r.querySelector(".jl-mm__tiles.is-active"))[0]?.focus()}}if(e.key==="ArrowLeft"){const t=i?.parentElement.closest("li");if(t){e.preventDefault();t.firstElementChild.focus();i.parentElement.parentElement.classList.remove("is-active");t.firstElementChild.setAttribute("aria-expanded","false")}else if(s?.closest("[data-jl-tiles]")){e.preventDefault();r.querySelector(".jl-mm__rail-link.is-active")?.focus()}}});document.addEventListener("keydown",e=>{if(e.key==="Escape"&&(r||closing.size)){e.preventDefault();const s=r?.querySelector("[data-jl-open]");m();s?.focus()}});document.addEventListener("pointerdown",e=>{if(!a.contains(e.target))m()});a.addEventListener("focusin",()=>clearTimeout(y));a.addEventListener("focusout",()=>setTimeout(()=>{if(!a.contains(document.activeElement))m()},0));addEventListener("resize",()=>{if(r){L(r);const e=r.querySelector(".jl-mm__rail-link.is-active");if(e)h(e);c(".jl-mm__flyout li.is-active",r).forEach(n)}})});window.JLMenu.initMobile = a=>{const d=a.querySelector(".jl-mm-mobile__list"),r=c("[data-jl-level]",a);const v=a.closest("details"),y=a.closest(".menu-drawer__navigation-container")||a;const p=[];const u=()=>p.at(-1)?.pane||d;const E=(l,n)=>typeof trapFocus==="function"?trapFocus(l,n):n.focus({preventScroll:true});const j=(l,n)=>{l.inert=!n;l.setAttribute("aria-hidden",String(!n))};const m=(l=true)=>{const n=p.pop();if(!n)return;n.pane.classList.remove("is-open");j(n.pane,false);n.button.setAttribute("aria-expanded","false");const o=u();o.classList.remove("is-parent");j(o,true);if(l)E(o,n.button);y.scrollTop=n.scroll};a.addEventListener("click",l=>{const n=l.target.closest("button");if(!n)return;if(n.hasAttribute("data-jl-mobile")){const o=r.find(s=>s.id===n.dataset.jlMobile);if(!o||n.closest("[data-jl-level],.jl-mm-mobile__list")!==u())return;const e=u();p.push({pane:o,button:n,scroll:y.scrollTop});e.classList.add("is-parent");j(e,false);o.classList.add("is-open");j(o,true);n.setAttribute("aria-expanded","true");g(o);E(o,o.querySelector(".jl-mm-mobile__back"));y.scrollTop=0}else if(n.classList.contains("jl-mm-mobile__back"))m()});let L=false;a.addEventListener("keydown",l=>{if(l.key==="Escape"&&p.length){l.preventDefault();l.stopPropagation();if(!l.repeat){m();L=true}}});a.addEventListener("keyup",l=>{if(l.key==="Escape"&&(L||p.length)){l.preventDefault();l.stopPropagation();if(!L)m();L=false}});let h=v?.open&&v.classList.contains("menu-opening");if(v)new MutationObserver(()=>{const l=v.open&&v.classList.contains("menu-opening");if(!l)while(p.length)m(false);else if(!h&&typeof trapFocus==="function")trapFocus(d,d.querySelector("button"));h=l}).observe(v,{attributes:true,attributeFilter:["open","class"]})};c(".jl-mm-mobile:not([data-jl-remote])").forEach(window.JLMenu.initMobile)})();

(()=>{
  "use strict";

  if (!("ResizeObserver" in window)) return;

  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)");
  const update = container => {
    const remaining = container.scrollHeight - container.clientHeight - container.scrollTop;
    container.classList.toggle("is-more", container.scrollHeight - container.clientHeight > 8 && remaining > 8);
  };
  const addHint = (container, rail = false) => {
    const hint = document.createElement("button");
    hint.type = "button";
    hint.className = "jl-mm__more";
    hint.tabIndex = -1;
    hint.setAttribute("aria-hidden", "true");
    hint.textContent = rail ? "↓" : "More below ↓";
    hint.addEventListener("click", () => {
      container.scrollBy({ top: container.clientHeight * .8, behavior: reduceMotion.matches ? "auto" : "smooth" });
    });
    container.append(hint);
    container.addEventListener("scroll", () => update(container), { passive: true });
    return hint;
  };

  document.querySelectorAll(".jl-mm--jainsons").forEach(menu => {
    menu.querySelectorAll(".jl-mm__rail-layout").forEach(layout => {
      const rail = layout.querySelector(":scope > .jl-mm__rail");
      const content = layout.querySelector(":scope > .jl-mm__rail-content");
      if (!rail || !content) return;

      addHint(rail, true);
      addHint(content);
      let active = content.querySelector("[data-jl-tiles].is-active");
      const refresh = () => {
        update(rail);
        update(content);
      };
      const observer = new ResizeObserver(refresh);
      observer.observe(rail);
      observer.observe(content);
      content.querySelectorAll("[data-jl-tiles]").forEach(tiles => observer.observe(tiles));
      new MutationObserver(() => {
        const next = content.querySelector("[data-jl-tiles].is-active");
        if (next && next !== active) {
          active = next;
          content.scrollTop = 0;
        }
        refresh();
      }).observe(content, { attributes: true, attributeFilter: ["class"], subtree: true });
      layout.closest("[data-jl-panel]").addEventListener("jl:hydrated", () => {
        refresh();
        requestAnimationFrame(refresh);
      });
      addEventListener("resize", refresh);
      refresh();
    });
  });
})();

// Search only the categories already present in each menu; no requests or dependencies.
(() => {
  "use strict";

  const all = (selector, root) => Array.from(root.querySelectorAll(selector));
  const label = node => {
    if (!node) return "";
    const copy = node.cloneNode(true);
    all('[aria-hidden="true"], noscript, .jl-mm__note, .jl-mm__well', copy)
      .forEach(child => child.remove());
    return copy.textContent.replace(/[→›▾▼]/g, "").replace(/\s+/g, " ").trim();
  };
  const words = value => value.toLowerCase().normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, " ").trim().split(/\s+/)
    .filter(Boolean).map(word => {
      if (word.length <= 3 || word.endsWith("ss")) return word;
      return word.endsWith("es") ? word.slice(0, -2) : word.replace(/s$/, "");
    });
  const hrefKey = href => href.toLowerCase().split(/[?#]/)[0].replace(/\/+$/, "");

  const inContent = (selector, root) => all(selector + ", template[data-jl-lazy]", root)
    .flatMap(node => node.matches("template[data-jl-lazy]")
      ? inContent(selector, node.content) : [node]);

  const buildIndex = (menu, mobile) => {
    const entries = [];
    const seen = new Map();
    const add = (node, title, path) => {
      const href = (node.getAttribute("href") || "").trim();
      if (!href || href === "#" || !title) return;
      const key = hrefKey(href);
      if (seen.has(key)) {
        const entry = seen.get(key);
        entry.extraTitles.push(title);
        return;
      }
      const tile = node.matches(mobile ? "a.jl-mm-mobile__tile" : "a.jl-mm__tile") ? node : null;
      const img = tile && tile.querySelector("img[data-src], img[src]");
      const entry = {
        href, title, path, tile, image: img ? img.getAttribute("data-src") || img.getAttribute("src") : "",
        extraTitles: [], order: entries.length
      };
      entries.push(entry);
      seen.set(key, entry);
    };
    if (mobile) {
      const panes = inContent("section[data-jl-level]", menu);
      panes.forEach(pane => {
        const ids = /^jl-mobile-(\d+)(?:-(\d+))?$/.exec(pane.id);
        if (!ids) return;
        const title = label(inContent(".jl-mm-mobile__title", pane)[0]);
        const parent = panes.find(item => item.id === "jl-mobile-" + ids[1]);
        const tab = label(parent && inContent(".jl-mm-mobile__title", parent)[0]);
        const path = ids[2] ? tab + " › " + title : title;
        inContent("a.jl-mm-mobile__tile, .jl-mm-mobile__section a", pane)
          .forEach(node => add(node, label(node), path));
        const group = inContent(".jl-mm-mobile__all", pane)[0];
        if (ids[2] && group) add(group, title, tab);
      });
    } else {
      inContent("[data-jl-panel]", menu).forEach(panel => {
        const tab = inContent(".jl-mm__tab", menu).find(node => node.id === panel.getAttribute("aria-labelledby"));
        const title = label(tab);
        const groups = inContent("[data-jl-tiles]", panel);
        groups.forEach(group => {
          const groupTitle = group.getAttribute("aria-label") || "";
          const path = title + " › " + groupTitle;
          inContent("a.jl-mm__tile, .jl-mm__section h3 a", group)
            .forEach(node => add(node, label(node), path));
          const rail = inContent("[data-jl-rail]", panel)
            .find(node => node.dataset.jlRail === group.dataset.jlTiles);
          if (rail) add(rail, groupTitle || label(rail), title);
        });
        if (!groups.length) {
          inContent("a.jl-mm__tile, .jl-mm__solutions-links a, .jl-mm__aside a", panel)
            .forEach(node => add(node, label(node), title));
        }
      });
    }
    entries.forEach(entry => {
      entry.titleWords = words(entry.title + " " + entry.extraTitles.join(" "));
      entry.matchWords = entry.titleWords.concat(words(entry.path));
    });
    return entries;
  };

  // At most one insertion, deletion or substitution. Prefix/substring matches run first.
  const oneEdit = (a, b) => {
    if (Math.abs(a.length - b.length) > 1) return false;
    let i = 0, j = 0, edits = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++edits > 1) return false;
      if (a.length >= b.length) i++;
      if (b.length >= a.length) j++;
    }
    return edits + (i < a.length || j < b.length ? 1 : 0) <= 1;
  };
  const matchWord = (query, targets) => {
    if (targets.some(word => word.startsWith(query) || (query.length >= 4 && word.includes(query)))) return 0;
    return query.length >= 5 && targets.some(word => oneEdit(query, word)) ? 1 : 2;
  };
  const search = (entries, query, limit) => {
    const terms = words(query);
    if (!terms.length) return [];
    return entries.map(entry => {
      const matches = terms.map(term => matchWord(term, entry.matchWords));
      if (matches.includes(2)) return null;
      return {
        entry,
        rank: [terms.every(term => matchWord(term, entry.titleWords) < 2) ? 0 : 1,
          words(entry.title)[0] && words(entry.title)[0].startsWith(terms[0]) ? 0 : 1,
          matches.includes(1) ? 1 : 0, entry.title.length, entry.order]
      };
    }).filter(Boolean).sort((a, b) => {
      for (let i = 0; i < a.rank.length; i++) {
        if (a.rank[i] !== b.rank[i]) return a.rank[i] - b.rank[i];
      }
      return 0;
    }).slice(0, limit).map(result => result.entry);
  };
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const productURL = query => {
    const base = window.routes && window.routes.search_url || "/search";
    return base + (base.includes("?") ? "&" : "?") + "q=" + encodeURIComponent(query);
  };
  const trackClick = query => {
    if (typeof window.clarity !== "function") return;
    try {
      window.clarity("event", "menu_search_click");
      window.clarity("set", "menu_search_q", query);
    } catch (_) { /* Analytics must never interrupt navigation. */ }
  };

  const enhance = (menu, mobile) => {
    let index;
    const getIndex = () => index || (index = buildIndex(menu, mobile));
    const prefix = mobile ? "jl-mm-mobile__search" : "jl-mm__search";
    const mounts = mobile ? [menu.querySelector(".jl-mm-mobile__list")] : all(".jl-mm__rail", menu);
    mounts.filter(Boolean).forEach(mount => {
      const panel = mobile ? menu : mount.closest("[data-jl-panel]");
      const content = mobile ? menu : panel.querySelector(".jl-mm__rail-content");
      if (!content) return;
      const box = element("div", prefix);
      const input = element("input", prefix + "-input");
      // Plain text (not type=search) so the site's search-suggestion and photo-search widgets leave it alone.
      input.type = "text";
      input.setAttribute("role", "searchbox");
      input.setAttribute("inputmode", "search");
      input.placeholder = "Find a category";
      input.setAttribute("aria-label", "Find a category in the menu");
      input.autocomplete = "off";
      input.setAttribute("enterkeyhint", "search");
      // The site's photo-search widget adds a camera button to every search box; this opts ours out.
      input.setAttribute("data-jlps-injected", "true");
      const clear = element("button", prefix + "-clear" + (mobile ? " no-control-menu" : ""), "×");
      clear.type = "button";
      clear.setAttribute("aria-label", "Clear");
      clear.hidden = true;
      box.append(input, clear);
      if (mobile) mount.before(box);
      else mount.prepend(box);
      const results = element("div", prefix + "-results");
      results.setAttribute("role", "region");
      results.setAttribute("aria-label", "Category search results");
      results.setAttribute("aria-live", "polite");
      results.hidden = true;
      if (mobile) mount.after(results);
      else content.append(results);

      let timer, saved, currentQuery = "", consumedEscape = false;
      let refreshPhoneTrap = () => {};
      const marker = () => {
        if (mobile) return;
        const active = panel.querySelector("[data-jl-rail].is-active");
        const mark = panel.querySelector(".jl-mm__marker");
        if (active && mark) {
          mark.style.top = active.offsetTop + "px";
          mark.style.height = active.offsetHeight + "px";
        }
      };
      marker();
      const restore = () => {
        panel.classList.remove("is-searching");
        if (mobile) mount.hidden = false;
        results.hidden = true;
        results.textContent = "";
        currentQuery = "";
        refreshPhoneTrap();
        if (!saved) return;
        if (!mobile) {
          saved.groups.forEach(([node, active]) => node.classList.toggle("is-active", active));
          saved.rails.forEach(([node, active]) => {
            node.classList.toggle("is-active", active);
            node.setAttribute("aria-expanded", String(active));
          });
          marker();
          mount.scrollTop = saved.railScroll;
          content.scrollTop = saved.contentScroll;
          // The existing hint observer resets scroll when an active group changes.
          // Restore again after that observer if the rail was used during search.
          const scroll = saved.contentScroll;
          Promise.resolve().then(() => {
            if (!panel.classList.contains("is-searching")) content.scrollTop = scroll;
          });
        }
        saved = null;
      };
      const render = () => {
        clearTimeout(timer);
        const query = input.value.trim();
        clear.hidden = !input.value;
        if (!query) { restore(); return; }
        const matches = search(getIndex(), query, mobile ? 30 : 24);
        if (!saved) {
          saved = mobile ? {} : {
            groups: all("[data-jl-tiles]", panel).map(node => [node, node.classList.contains("is-active")]),
            rails: all("[data-jl-rail]", panel).map(node => [node, node.classList.contains("is-active")]),
            railScroll: mount.scrollTop, contentScroll: content.scrollTop
          };
        }
        currentQuery = query;
        panel.classList.add("is-searching");
        if (mobile) mount.hidden = true;
        results.hidden = false;
        results.textContent = "";
        results.append(element("p", prefix + "-heading", matches.length
          ? matches.length + (matches.length === 1 ? " category" : " categories") + " for “" + query + "”" : "No category called “" + query + "”."));
        const grid = element("div", prefix + "-grid");
        matches.forEach(entry => {
          let link;
          if (!mobile && entry.tile) {
            link = entry.tile.cloneNode(true);
            all("noscript, .jl-mm__note", link).forEach(node => node.remove());
            all("[id]", link).forEach(node => node.removeAttribute("id"));
            link.removeAttribute("id");
            all("img", link).forEach(img => {
              img.src = img.getAttribute("data-src") || img.getAttribute("src") || entry.image;
              img.removeAttribute("data-src");
            });
          } else {
            link = element("a", mobile ? prefix + "-row" : "jl-mm__tile jl-mm__tile--text vc v10");
            if (mobile && entry.image) {
              link.classList.add(prefix + "-row--photo");
              const img = element("img", prefix + "-thumb");
              img.src = entry.image;
              img.alt = "";
              img.width = img.height = 48;
              link.append(img);
            }
            link.append(element("span", prefix + "-label", entry.title));
          }
          link.href = entry.href;
          link.classList.add(prefix + "-result");
          if (!mobile) link.setAttribute("role", "menuitem");
          link.append(element("small", prefix + "-path", entry.path));
          link.addEventListener("click", () => trackClick(query));
          grid.append(link);
        });
        results.append(grid);
        const products = element("a", prefix + "-products", "Search all products for “" + query + "” →");
        products.href = productURL(query);
        if (!mobile) products.setAttribute("role", "menuitem");
        results.append(products);
        if (!mobile) content.scrollTop = 0;
        refreshPhoneTrap();
      };
      const reset = () => {
        input.value = "";
        render();
        input.focus({ preventScroll: true });
      };
      input.addEventListener("focus", getIndex, { once: true });
      input.addEventListener("input", () => {
        clearTimeout(timer);
        clear.hidden = !input.value;
        if (!input.value.trim()) render();
        else timer = setTimeout(render, 80);
      });
      clear.addEventListener("click", reset);
      const searchKeydown = event => {
        if (event.key === "Escape" && !input.value) return;
        if (mobile && event.key === "Tab") return;
        // The original desktop arrow handler expects an anchor as its event target.
        event.stopPropagation();
        if (event.key === "Escape") {
          event.preventDefault();
          consumedEscape = true;
          reset();
        } else if (event.target === input && (event.key === "Enter" || event.key === "ArrowDown")) {
          event.preventDefault();
          if (currentQuery !== input.value.trim()) render();
          const first = results.querySelector("a");
          if (event.key === "ArrowDown") { if (first) first.focus(); }
          else if (first) first.click();
        }
      };
      const searchKeyup = event => {
        if (event.key === "Escape" && consumedEscape) {
          event.stopPropagation();
          consumedEscape = false;
        }
      };
      box.addEventListener("keydown", searchKeydown);
      box.addEventListener("keyup", searchKeyup);
      // Results are siblings of the box. Esc from a result also clears before
      // the drawer/menu sees it; reset moves focus back into the input.
      results.addEventListener("keydown", event => {
        if (event.key === "Escape") searchKeydown(event);
      });
      results.addEventListener("keyup", searchKeyup);

      if (mobile) {
        const drawer = menu.closest("details");
        const trapRoot = menu.closest(".menu-drawer__navigation-container") || menu;
        const mainLevelOpen = () => !box.hidden && drawer && drawer.open && drawer.classList.contains("menu-opening");
        const focusable = node => node.tabIndex >= 0 && !node.disabled &&
          !node.closest('[hidden], [inert], [aria-hidden="true"]') &&
          node.getClientRects().length && getComputedStyle(node).visibility === "visible";
        // Wrap only at the main level's boundaries, using a fresh list so newly
        // rendered results/clear controls participate even without Woodstock.
        // Capture runs before a theme trap still pointing at the old main list.
        trapRoot.addEventListener("keydown", event => {
          if (event.key !== "Tab" || !mainLevelOpen()) return;
          const nodes = all('summary, a[href], button, input, select, textarea, [tabindex]', trapRoot).filter(focusable);
          if (!nodes.length) return;
          const position = nodes.indexOf(document.activeElement);
          if (position < 0 || (event.shiftKey ? position === 0 : position === nodes.length - 1)) {
            event.preventDefault();
            event.stopPropagation();
            nodes[event.shiftKey ? nodes.length - 1 : 0].focus({ preventScroll: true });
          }
        }, true);
        refreshPhoneTrap = () => {
          box.hidden = mount.classList.contains("is-parent");
          results.hidden = box.hidden || !input.value.trim();
          if (!mainLevelOpen()) return;
          // The existing pane handler traps the main list alone. Include its new siblings
          // when returning to that level, using Woodstock's own trap implementation.
          const focused = document.activeElement;
          const focus = trapRoot.contains(focused) && focusable(focused) ? focused : input;
          if (typeof window.trapFocus === "function") {
            window.trapFocus(trapRoot, focus);
          } else if (focus !== focused) focus.focus({ preventScroll: true });
        };
        new MutationObserver(refreshPhoneTrap).observe(mount, { attributes: true, attributeFilter: ["class"] });
        if (drawer) new MutationObserver(refreshPhoneTrap).observe(drawer, {
          attributes: true, attributeFilter: ["open", "class"]
        });
        refreshPhoneTrap();
      }
    });
  };
  all(".jl-mm", document).forEach(menu => enhance(menu, false));
  window.JLMenu.enhanceMobile = menu => enhance(menu, true);
  all(".jl-mm-mobile:not([data-jl-remote])", document).forEach(window.JLMenu.enhanceMobile);
})();

// Shortcuts to the headings in long, sectioned groups (desktop and drawer).
(() => {
  "use strict";

  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)");
  const headingLabel = heading => heading.textContent.replace(/→/g, "")
    .replace(/\s+/g, " ").trim();

  // Resolve this on click: closed panes have no measurable scroll area. The
  // drawer normally scrolls, but a theme can give the pane its own scroll area.
  const phoneScroller = pane => {
    const menu = pane.closest(".jl-mm-mobile");
    const drawer = menu.closest(".menu-drawer__navigation-container");
    for (let node = pane; node; node = node.parentElement) {
      if (/(auto|scroll|overlay)/.test(getComputedStyle(node).overflowY) &&
          node.scrollHeight > node.clientHeight) return node;
      if (node === (drawer || menu)) break;
    }
    return drawer || menu;
  };

  const addJumps = (group, headings, mobile) => {
    if (headings.length < 2 || group.querySelector(":scope > .jl-mm__jump")) return;
    const mount = mobile
      ? group.querySelector(":scope > .jl-mm-mobile__all") || group.querySelector(":scope > .jl-mm-mobile__header")
      : group.querySelector(":scope > .jl-mm__group-header");
    if (!mount) return;

    const nav = document.createElement("nav");
    nav.className = "jl-mm__jump" + (mobile ? " jl-mm__jump--mobile" : "");
    nav.setAttribute("aria-label", "Jump to section");
    headings.forEach(heading => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "jl-mm__jump-chip" + (mobile ? " no-control-menu" : "");
      button.textContent = headingLabel(heading);
      button.addEventListener("click", () => {
        const scroller = mobile ? phoneScroller(group) : group.closest(".jl-mm__rail-content");
        if (!scroller) return;
        const header = mobile && group.querySelector(":scope > .jl-mm-mobile__header");
        const headerStyle = header && getComputedStyle(header);
        const inset = headerStyle && headerStyle.position === "sticky"
          ? header.offsetHeight + (parseFloat(headerStyle.top) || 0) : 0;
        const top = scroller.scrollTop + heading.getBoundingClientRect().top
          - scroller.getBoundingClientRect().top - scroller.clientTop - inset;
        scroller.scrollTo({ top: Math.max(0, top), behavior: reduceMotion.matches ? "instant" : "smooth" });
        const link = heading.querySelector("a[href]");
        if (link) link.focus({ preventScroll: true });
      });
      nav.append(button);
    });
    if (!mobile) {
      // The original menu's arrow handler expects anchors, not these buttons.
      // Let Tab, Enter, Space and Escape keep their usual behavior.
      nav.addEventListener("keydown", event => {
        if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(event.key)) {
          event.stopPropagation();
        }
      });
    }
    mount.after(nav);
  };

  const enhanceJumps = root => {
    const groups = Array.from(root.querySelectorAll("[data-jl-tiles], .jl-mm-mobile section[data-jl-level]"));
    if (root.matches && root.matches("[data-jl-tiles], .jl-mm-mobile section[data-jl-level]")) groups.unshift(root);
    groups.forEach(group => {
      const mobile = group.matches("section[data-jl-level]");
      const headings = group.querySelectorAll(mobile ? "h3.jl-mm-mobile__section" : ".jl-mm__section > h3");
      addJumps(group, Array.from(headings), mobile);
    });
  };
  enhanceJumps(document);
  document.addEventListener("jl:hydrated", event => enhanceJumps(event.target));
})();

// CUSTOM-START SPEED-S1: load the mobile panes once; preserve the live top-level list.
(function () {
  var menu = document.querySelector('.jl-mm-mobile[data-jl-remote]');
  if (!menu) return;
  var drawer = menu.closest('details');
  var summary = drawer && drawer.querySelector('summary');
  var pending = null;
  var loaded = false;
  function load() {
    if (loaded) return Promise.resolve();
    if (pending) return pending;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    pending = fetch(root + '?section_id=jl-mm-mobile-lazy').then(function (response) {
      if (!response.ok) throw new Error('Menu request failed');
      return response.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var remote = doc.querySelector('.jl-mm-mobile');
      if (!remote) throw new Error('Menu response missing');
      var panes = remote.querySelectorAll('[data-jl-level]');
      if (!panes.length && menu.querySelector('[data-jl-mobile]')) throw new Error('Menu panes missing');
      Array.prototype.forEach.call(panes, function (pane) { menu.appendChild(pane); });
      window.JLMenu.initMobile(menu);
      window.JLMenu.enhanceMobile(menu);
      menu.removeAttribute('data-jl-remote');
      loaded = true;
    }).catch(function (error) { pending = null; throw error; });
    return pending;
  }
  function prefetch() { load().catch(function () {}); }
  menu.addEventListener('click', function (event) {
    var button = event.target.closest('button[data-jl-mobile]');
    if (!button || loaded) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    load().then(function () { if (!drawer || drawer.open) button.click(); }).catch(function () {
      window.location.href = button.getAttribute('data-jl-fallback') || '/collections/all';
    });
  }, true);
  if (summary) {
    summary.addEventListener('touchstart', prefetch, { passive: true, once: true });
    summary.addEventListener('click', prefetch);
  }
  function idle() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(prefetch, { timeout: 8000 });
    else window.setTimeout(prefetch, 1000);
  }
  if (document.readyState === 'complete') idle();
  else window.addEventListener('load', idle, { once: true });
})();
// CUSTOM-END SPEED-S1
